import { http } from 'interfaces'
import { type Chamber } from 'components'

export interface CommitteeFilterResults {
  data: Committee[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export interface Committee {
  id: number
  name?: string | null
  state?: string | null
  chamber?: Chamber
  active?: boolean
}

export async function committeeListFilter (params: any): Promise<CommitteeFilterResults> {
  return await http.get('/api/v1/us/committee', {
    params: { ...params }
  }).then(value => value.data)
    .catch(reason => { return { data: [], page_number: 0, page_size: 0, total_items: 0, total_pages: 0 } })
}
